import { Controller } from "@hotwired/stimulus";

/**
 * button-toggle-input
 *
 * Fix pour les groupes Bootstrap `data-toggle="buttons"`:
 * - Bootstrap toggle la classe `.active`/`checked`, mais ne déclenche pas toujours un `change/input`
 *   sur l'input, ce qui empêche api-sync de partir au 1er clic.
 *
 * Usage:
 *   <div data-controller="button-toggle-input" data-action="click->button-toggle-input#clicked">
 *     <label><input ...></label>
 *   </div>
 */
export default class extends Controller {
  clicked(event) {
    const t = event?.target;
    if (!t || !t.closest) return;

    const label = t.closest("label");
    let input =
      (t.tagName === "INPUT" ? t : null) ||
      label?.querySelector?.("input[type='checkbox'], input[type='radio']") ||
      t.closest?.("input[type='checkbox'], input[type='radio']");

    // Handle labels that reference an input by id (rare, but robust).
    if (!input && label?.htmlFor) {
      try { input = document.getElementById(label.htmlFor); } catch (_) {}
    }

    if (!input) return;

    // Bootstrap `data-toggle="buttons"` ne garantit pas la mise à jour de `input.checked`
    // dans tous les contextes (delegation, click sur label, etc.).
    // Pour rendre ça déterministe, on force le toggle ici.
    try { event?.preventDefault?.(); } catch (_) {}

    try {
      if (input.type === "checkbox") {
        input.checked = !input.checked;
        if (label && label.classList) label.classList.toggle("active", input.checked);
        try {
          input.dispatchEvent(new Event("input", { bubbles: true }));
          input.dispatchEvent(new Event("change", { bubbles: true }));
        } catch (_) {}
      } else if (input.type === "radio") {
        // Radio groups: ensure exclusivity and update `.active` on labels.
        if (input.checked) return;
        input.checked = true;

        const group =
          label?.closest?.("[data-toggle='buttons']") ||
          label?.closest?.(".btn-group-toggle") ||
          this.element;

        const name = input.getAttribute("name") || "";
        if (name) {
          const escapedName =
            (typeof CSS !== "undefined" && CSS && typeof CSS.escape === "function")
              ? CSS.escape(name)
              : name.replace(/["\\]/g, "\\$&");
          const radios = group?.querySelectorAll?.(`input[type='radio'][name="${escapedName}"]`) || [];
          radios.forEach((r) => {
            if (r === input) return;
            try { r.checked = false; } catch (_) {}
            const l = r.closest?.("label");
            if (l?.classList) l.classList.toggle("active", false);
          });
        }

        if (label?.classList) label.classList.toggle("active", true);
        try {
          input.dispatchEvent(new Event("input", { bubbles: true }));
          input.dispatchEvent(new Event("change", { bubbles: true }));
        } catch (_) {}
      }
    } catch (_) {}

    
  }
}

